import { render } from "./LoginModal.vue?vue&type=template&id=753a490b&scoped=true&ts=true"
import script from "./LoginModal.vue?vue&type=script&lang=ts"
export * from "./LoginModal.vue?vue&type=script&lang=ts"

import "./LoginModal.vue?vue&type=style&index=0&id=753a490b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753a490b"]])

export default __exports__